import { Button } from "@station/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape } from "../../../features/accounting/company.js";
import { TreasuryPage } from "../../../features/treasury/shared.js";
import { TransactionsList } from "../../../features/treasury/transactions-list.js";
import { usePermissions } from "../../../lib/session.js";

export const Route = createFileRoute("/_app/finans/hareketler")({
  validateSearch: (search) => z.object(companySearchShape).parse(search),
  component: TreasuryTransactionsPage,
});

function TreasuryTransactionsPage() {
  const { t } = useTranslation();
  const permissions = usePermissions();
  return (
    <TreasuryPage
      title={t("menu.treasuryTransactions")}
      description={t("treasury.txn.listDescription")}
      actions={
        permissions.has("treasury.txn.create") ? (
          <Button asChild>
            <Link to="/finans/hareket-yeni">
              <Plus aria-hidden="true" />
              {t("treasury.txn.new")}
            </Link>
          </Button>
        ) : null
      }
    >
      {({ companyId }) => <TransactionsList companyId={companyId} caption={t("menu.treasuryTransactions")} />}
    </TreasuryPage>
  );
}
